import styled from 'styled-components'
import { Box } from '../../atoms/Box'
import { Text } from '../../atoms/Text'

export const PermitsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
  background: ${({ theme }) => theme.colors.background.primary};
`

export const PermitsStatsSection = styled(Box)`
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: 6px;
  padding-top: 16px;
`

export const PermitsMetricCard = styled(Box)<{ $accent?: boolean }>`
  background: ${({ $accent, theme }) =>
    $accent
      ? `linear-gradient(135deg, ${theme.colors.primary}10 0%, ${theme.colors.primary}05 100%)`
      : theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: 6px;
  padding: 12px;
  min-width: 120px;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${({ theme }) => theme.shadows.sm};
  }
`

export const PermitsMetricLabel = styled(Box)`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 10px;
  color: ${({ theme }) => theme.colors.text.secondary};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
`

export const PermitsMetricValue = styled(Text)<{ color?: string }>`
  font-size: 16px;
  font-weight: 700;
  color: ${({ color, theme }) => color || theme.colors.text.primary};
  margin-bottom: 3px;
`

export const PermitsEmptyState = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.huge};
  gap: ${({ theme }) => theme.spacing.large};
  background: white;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  box-shadow: ${({ theme }) => theme.shadows.sm};
`

export const PermitsEmptyStateIcon = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: ${({ theme }) => theme.colors.background.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.circle};
`

export const PermitsEmptyStateText = styled(Box)`
  text-align: center;
  max-width: 400px;

  > :first-child {
    margin-bottom: ${({ theme }) => theme.spacing.small};
  }
`
